import { render, staticRenderFns } from "./page-play.vue?vue&type=template&id=bb58f10e&scoped=true"
import script from "./page-play.vue?vue&type=script&lang=js"
export * from "./page-play.vue?vue&type=script&lang=js"
import style0 from "./page-play.vue?vue&type=style&index=0&id=bb58f10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58f10e",
  null
  
)

export default component.exports